import { defineMessages } from 'react-intl';

export default defineMessages({
  dealerInventory: {
    id: 'dealerInventory',
    description: 'Quota Details Dealer Inventory Heading',
    defaultMessage: 'Dealer Inventory',
  },
  processingCenter: {
    id: 'processingCenter',
    description: 'Quota Details Processing Center Heading',
    defaultMessage: 'Processing Center',
  },
  inTransitToVPS: {
    id: 'inTransitToVPS',
    description: 'Quota Details In Transit to VPS Heading',
    defaultMessage: 'In Transit to VPS',
  },
  scheduledInProduction: {
    id: 'scheduledInProduction',
    description: 'Quota Details Scheduled/In Production Heading',
    defaultMessage: 'Scheduled/In Production',
  },
  producedNotShipped: {
    id: 'producedNotShipped',
    description: 'Quota Details Produced/Not Shipped Heading',
    defaultMessage: 'Produced/Not Shipped',
  },
  onOrder: {
    id: 'onOrder',
    description: 'Quota Details On Order Heading',
    defaultMessage: 'On Order',
  },
  allocation: {
    id: 'allocation',
    description: 'Quota Details Allocation Heading',
    defaultMessage: 'Allocation',
  },
  currency: {
    id: 'currency',
    description: 'USD',
    defaultMessage: 'USD',
  },
  priceBandLabel: {
    id: 'pbAbbreviation',
    description: 'PB',
    defaultMessage: 'PB',
  },
  clearFiltersLabel: {
    id: 'clearFilters',
    description: 'Clear Filters',
    defaultMessage: 'Clear Filters',
  },
});
